// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class ExtEnrollmentRequestModel {
    static getAttributeTypeMap() {
        return ExtEnrollmentRequestModel.attributeTypeMap;
    }
}
ExtEnrollmentRequestModel.discriminator = undefined;
ExtEnrollmentRequestModel.additionalProperties = false;
ExtEnrollmentRequestModel.attributeTypeMap = [
    {
        "name": "survey",
        "baseName": "survey",
        "type": ""
    },
    {
        "name": "demographics",
        "baseName": "demographics",
        "type": "ExtEnrollmentDemographicsModel"
    },
    {
        "name": "clientIdentifiers",
        "baseName": "clientIdentifiers",
        "type": "ExtEnrollmentClientIdentifiersModel"
    },
];
//# sourceMappingURL=extEnrollmentRequestModel.js.map